import React, { FunctionComponent, Suspense, useMemo } from 'react';
import { BrowserRouter, Route, Routes }                from 'react-router-dom';
import { FallbackRoute }                               from './FallbackRoute';
import { PublicApp }                                   from 'View/Application/PublicApp/PublicApp';
import { PrivateApp }                                  from 'View/Application/PrivateApp/PrivateApp';
import { IsUserLoggedIn }                              from 'View/Application/IsUserLoggedIn/IsUserLoggedIn';
import { isUserLoggedIn }                              from 'Redux/Queries';
import { useSelector }                                 from 'react-redux';
import { linkHandler }                                 from 'Utils';

interface IProps {
  children?: React.ReactNode;
}

export const Router: FunctionComponent<IProps> = ({ children }) => {

  const isAuthenticated = useSelector(isUserLoggedIn);
  const renderFallBack = () => {
    return <>Loading ...</>;
  };

  const routes = useMemo(
    () => {
      const _routes = linkHandler.getAllRoutes();
      return Object.keys(_routes)
        .filter((routeKey) => !_routes[routeKey]?.private || (isAuthenticated && _routes[routeKey]?.private))
        .map((routeKey) => _routes[routeKey])
    },
  [ isAuthenticated ]
  );

  const renderComponent = ({ Component, privateRoute }: { Component: typeof React.Component | React.LazyExoticComponent<any>; privateRoute?: boolean }) => {
    if (!privateRoute) {
      return (
        <PublicApp>
          <Component/>
        </PublicApp>
      );
    }

    return (
      <PrivateApp>
        <Component/>
      </PrivateApp>
    );
  };

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/*" element={<FallbackRoute/>}/>
        {routes
          .filter(({ Component }) => !!Component)
          .map(({ path, Component, private: privateRoute }, index) => (
              <Route
                path={path}
                key={`Route-${index}__${path}`}
                element={
                  <Suspense fallback={renderFallBack()}>
                    {renderComponent({ Component: Component!, privateRoute })}
                  </Suspense>
                }
              />
            )
          )}
      </Routes>
      <IsUserLoggedIn/>
      {children}
    </BrowserRouter>
  );
};
